import { ServiceExecutionSequenceModel } from 'app/app-model/diagnostic-service/service-execution-sequence.model';

export class EcuValueModel {
  name: string;
  readSequence: ServiceExecutionSequenceModel;
  writeSequence: ServiceExecutionSequenceModel;
}
